import React from 'react';

import Header from '../../components/Header';
import LoginForm from '../../components/Login/LoginForm';
import LoginAvantages from '../../interface/LoginAvantages';

import { LoginLoc } from '../../loc/login';
import { loc } from '../../lib/loc';

export default function Login() {
    return (
        <>
            <Header title={loc(LoginLoc.pageTitle)} />
            <div className="wrap-page-content">
                <div className="login-page pt-80 pb-150">
                    <div className="login-page__container">
                        <div className="login-page__wrap-elemets-page">
                            <div className="login-page__left-col" style={{ display: 'inherit' }}>
                                <LoginForm />
                            </div>
                            <div className="login-page__right-col">
                                <LoginAvantages />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
